import {combineReducers} from "redux";
import Division from "./Division";
import Papers from "./Papers";
import EdgesData from "./Edges";
import NodesData from "./Nodes";
import PaperEdges from "./paperEdges";
import Scale from "./Scale"
import Years from "./Years"

export default combineReducers({Division, Papers, NodesData, EdgesData, PaperEdges, Scale, Years});